import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
// Core Components import
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import Button from 'yoda-core-components/lib/components/Button';
// Site Components import
import User from 'yoda-site-components/lib/helpers/User/User';
import CertonaZone from 'yoda-site-components/lib/components/CertonaZone/CertonaZone';
import CAMNavLayout from 'yoda-site-components/lib/components/CAMNav/WithLayout';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import Canonincalize from 'yoda-account-components/lib/components/Canonincalize/Canonincalize';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ListDetailsPanel from './ListDetailsPanel/ListDetailsPanel';
import FilterPanel from '../../../components/Lists/FilterPanel/FilterPanel';
import { addQueryNewUrl } from '../../../common/UrlHelper';
import { getSavedItems } from '../../../common/getSavedItems';
import { listDuplicateListMessage } from '../../../common/Constants';
import * as styles from './ListLandingPage.css';

const cx = classNames.bind(styles);
class ListLandingPage extends SiteComponent {
    static defaultProps = {
        featureFlags: {},
        myListsDetails: {},
        authenticationSuccess: false,
        mountOnServer: false,
        location: {
            pathname: '',
            query: {},
            search: '',
        },
        updatedItem: {},
        firstName: '',
        isOOSListingEnabled: false,
        myAlertsProps: {},
        MTLSavedLists: {},
    };

    static propTypes = {
        myListsDetails: PropTypes.objectOf(
            PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        ).isRequired,
        featureFlags: PropTypes.objectOf.isRequired,
        savedList: PropTypes.objectOf.isRequired,
        addToCart: PropTypes.objectOf(PropTypes.object).isRequired,
        addToCartActions: PropTypes.objectOf(PropTypes.object).isRequired,
        LoaderAction: PropTypes.objectOf(PropTypes.object).isRequired,
        MiniPDPActions: PropTypes.objectOf(PropTypes.object).isRequired,
        toggleMostWanted: PropTypes.objectOf.isRequired,
        shareList: PropTypes.objectOf.isRequired,
        siteAccountAction: PropTypes.objectOf(PropTypes.object).isRequired,
        messagesTexts: PropTypes.objectOf.isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
            basename: PropTypes.string.isRequired,
            query: PropTypes.objectOf(PropTypes.object).isRequired,
            search: PropTypes.string.isRequired,
        }).isRequired,
        draftOrder: PropTypes.objectOf(PropTypes.object).isRequired,
        headers: PropTypes.objectOf.isRequired,
        actions: PropTypes.objectOf.isRequired,
        savedListActions: PropTypes.objectOf.isRequired,
        accounts: PropTypes.objectOf.isRequired,
        deviceType: PropTypes.objectOf.isRequired,
        mountOnServer: PropTypes.bool.isRequired,
        deleteList: PropTypes.objectOf.isRequired,
        userState: PropTypes.string.isRequired,
        isOOSListingEnabled: PropTypes.bool.isRequired,
        updatedItem: PropTypes.objectOf(PropTypes.object),
        authenticationSuccess: PropTypes.bool,
        firstName: PropTypes.string,
        myAlertsProps: PropTypes.object,
        MTLSavedLists: PropTypes.object,
        lastRemovedListItem: PropTypes.object,
    };

    constructor(props) {
        super(props);
        const { location } = props;
        const search = get(location, 'search', '');
        const query = makeQuery(search);
        this.state = {
            currentPage: 1,
            showMessage: false,
            message: '',
            type: '',
            atcSuccess: false,
            isSharedListPrivate: false,
            isShared: get(query, 'token') || false,
            movedId: '',
            movedTo: '',
        };
        this.closeSuccessMsg = this.closeSuccessMsg.bind(this);
    }

    componentWillReceiveProps(props) {
        if (
            get(props, 'savedList.statusCode') &&
            get(props, 'savedList.statusCode') === 412 &&
            this.state.isShared
        ) {
            this.setState({ isSharedListPrivate: true });
        }

        if (
            props.authenticationSuccess &&
            props.authenticationSuccess !== this.props.authenticationSuccess
        ) {
            this.props.actions.getLists();
            this.setState({
                currentPage: 1,
            });
        }

        const userSignedOut =
            props.userState && props.userState !== this.props.userState && props.userState === '0';
        if (userSignedOut) {
            this.props.actions.getLists();
            this.setState({
                currentPage: 1,
            });
        }
    }

    closeSuccessMsg = () => {
        this.setState({
            atcSuccess: false,
            showMessage: false,
        });
    };

    getListCategorySort = ({ sort, listId }) => {
        const { location } = this.props;
        const query = makeQuery(location.search);
        const { currentPage } = this.state;
        const authStatus = TokenProvider.get('DP_USER_STATE');
        const isGuestMode = authStatus !== '1';
        this.props.savedListActions.getListCategory(
            listId,
            { sort, page: currentPage },
            getSavedItems(authStatus, false, false, listId),
            get(query, 'token', ''),
            get(query, 'accountId', ''),
            isGuestMode
        );
        this.setState({ sort });
    };

    openSlider = () => {
        const { featureFlags, siteAccountAction } = this.props;
        const isHideAccountMenu = get(featureFlags, 'isHideAccountMenuSlider', false);
        const customizeConfig = {
            forceLogin: true,
            skipOnAuthenticationSuccess: true,
            isHideAccountMenu: true,
            isSliderCustomized: true,
        };
        if (featureFlags.enableSignInSlider) {
            isHideAccountMenu
                ? siteAccountAction.customStepUp(customizeConfig)
                : siteAccountAction.openSignInSlider();
        } else {
            window.location.assign('/signin?next=/mylist');
        }
    };

    hydrateOnMount() {
        if (
            this.props.headers.cookies &&
            this.props.headers.cookies.DP_USER_STATE &&
            this.props.headers.cookies.DP_USER_STATE !== '0' &&
            !this.props.myListsDetails.listItems.listData
        ) {
            this.props.actions.getLists(undefined, this.props.headers);
        }
    }

    componentDidMount() {
        const { location } = this.props;
        const query = makeQuery(location.search);
        const listId = get(query, 'id');
        /* istanbul ignore else */
        if (isEmpty(listId)) {
            const queryNew = { id: 'myFavorites' };
            addQueryNewUrl(queryNew);
        }
        /**
         * Only calling this for not logged in user, this will happen on client side
         */
        if (!this.isUserLoggedOn() && !this.props.myListsDetails.listItems.listData) {
            const localData = getSavedItems('0');
            /* istanbul ignore else */
            if (localData) {
                this.props.actions.getLists(localData);
            }
        }
        const analyticsData = {
            trackEvent: 'digitalDataReady',
            pageName: 'list landing page',
        };
        this.props.actions.myListAnalyticsAction(analyticsData);
        const { showCopyListSuccessMsg, copyListName } = this.props.myListsDetails;
        if (showCopyListSuccessMsg && copyListName) {
            this.showTopMessage('success', `${copyListName} has been copied successfully.`);
        }
        const newMyList = TokenProvider.get('DP_USER_NEW_MY_LIST');
        if (newMyList) {
            this.showTopMessage('success', 'Your list was created!');
            TokenProvider.set('DP_USER_NEW_MY_LIST', '');
        }
    }

    isUserLoggedOn = () => {
        let isLoggedIn = false;
        /* istanbul ignore else */
        if (!__SERVER__) {
            isLoggedIn = User.isUserLoggedIn();
        } else {
            const userStateAtServer = get(this.props, 'headers.cookies.DP_USER_STATE', '0');
            isLoggedIn = userStateAtServer !== '0';
        }

        return isLoggedIn;
    };

    closeMessageBox = () => {
        const { showCopyListSuccessMsg } = this.props.myListsDetails;
        if (showCopyListSuccessMsg) {
            this.props.actions.showCopyListSuccessMessage({ show: false });
        }
        this.setState({
            showMessage: false,
        });
    };

    showTopMessage = (type, message, movedTo = '', movedId = '') => {
        this.setState({
            showMessage: true,
            message,
            type,
            movedTo,
            movedId,
        });
    };

    atcSuccess = () => {
        const atcSuccess = get(this.props, 'addToCart.isAddToCartSuccess', false);
        if (!this.state.atcSuccess && atcSuccess) {
            this.showTopMessage('success', 'Item has been moved to cart.');
            this.setState({
                atcSuccess: true,
            });

            return true;
        }
        return false;
    };

    render() {
        const {
            myListsDetails,
            featureFlags,
            preferences,
            actions,
            headers,
            siteAccountAction,
            location,
            messagesTexts,
            deviceType,
            addToCart,
            addToCartActions,
            LoaderAction,
            shareList,
            savedList,
            toggleMostWanted,
            accounts,
            savedListActions,
            authenticationSuccess,
            mountOnServer,
            deleteList,
            MiniPDPActions,
            updatedItem,
            userState,
            firstName,
            error,
            isOOSListingEnabled,
            myAlertsProps,
            MTLSavedLists,
            lastRemovedListItem,
        } = this.props;
        const { atcSuccess, isShared, isSharedListPrivate, movedId, movedTo } = this.state;
        const { isLoading } = myListsDetails;
        const { message, type, showMessage } = this.state;
        const typeInfoTheme = {
            privacyLabel: `${cx('privacyLabel')}`,
            curatedLabel: `${cx('curatedLabel')}`,
        };
        const isDataLoaded = !isEmpty(savedList);
        const productsList = get(savedList, 'data.items', []);
        const isMyFavourites = get(savedList, 'data.id', 'myFavorites') === 'myFavorites' || false;
        let itemid = [];
        /* istanbul ignore else */
        if (productsList) {
            for (let i = 0; i < productsList.length; i += 1) {
                productsList[i].product &&
                    productsList[i].product.id &&
                    itemid.length <= 10 &&
                    itemid.push(`${productsList[i].product.id};`);
            }
        }
        itemid = itemid.toString().replace(/,/g, '');
        let pageType;
        let slotType;
        if (isMyFavourites) {
            pageType = 'FAVORITES';
            slotType = 'favoritesrecs1_rr';
        } else {
            pageType = 'WISHLIST';
            slotType = 'listdetail_rr';
        }
        /* istanbul ignore next */
        const renderRecZone = () =>
            // This would make sure that dont load RecZone till data is loaded
            isDataLoaded && (
                <CertonaZone
                    page="LISTING"
                    slotDetails={{
                        pageType: `${pageType}`,
                        attributes: { itemid: `${itemid}`, recommendations: true },
                        loader: 'certona',
                        slotId: `${slotType}`,
                        forceRefresh: true,
                    }}
                    schemasToRender={[`${slotType}`]}
                />
            );
        const pageTitle = isShared ? 'Shared List' : 'My Lists';
        const query = makeQuery(location.search);
        return (
            <div>
                <Canonincalize urlLocation={location.pathname} />
                <CAMNavLayout
                    layoutState={{
                        title: userState !== '0' && firstName ? `Hi, ${firstName}!` : pageTitle,
                    }}
                    classes={{
                        layoutHeaderClass: `${cx('md12')} ${dt(['smOnly:!mt-5'])}`,
                        panelContentContainer: `${cx('content-container', 'md12')} ${dt(['mt-0'])}`,
                        root: cx('layout-container'),
                    }}
                    location={location}
                    enableSignInSlider={featureFlags.enableSignInSlider}
                    actions={siteAccountAction}
                    renderRecZone={renderRecZone}
                >
                    {(isLoading || myAlertsProps.isLoader) && (
                        <Loader keepOverlay automationId="test-automation-loader-1" />
                    )}
                    {!this.isUserLoggedOn() && (
                        <section className={`${cx('listBanner')} ${dt(['mb-4', 'smOnly:py-0'])}`}>
                            <div
                                className={`${cx('listBannerWrapper')} ${dt([
                                    'p-4',
                                    'flex',
                                    'justify-between',
                                    'items-center',
                                    'flex-wrap',
                                    'border-t',
                                    'border-b',
                                    'border-solid',
                                    'border-gray-15',
                                ])}`}
                            >
                                <div
                                    className={`${cx('text')} ${dt([
                                        'text-large',
                                        'font-open-sans-semibold',
                                        'transform',
                                        'text-black',
                                        'inline-block',
                                        'smOnly:w-full',
                                    ])}`}
                                >
                                    Sign in to create, manage, and share your lists.
                                </div>
                                <div
                                    data-automation-id="signinBtnBlock"
                                    className={`${cx('button')} ${dt([
                                        'inline-block',
                                        'md:pl-4',
                                        'smOnly:pt-4',
                                        'smOnly:w-full',
                                    ])}`}
                                >
                                    <Button
                                        buttonType="Primary"
                                        size="Md"
                                        className={dt(['md:w-[100px]', 'smOnly::w-full'])}
                                        automationId="signinBtn"
                                        onClick={this.openSlider}
                                    >
                                        Sign In
                                    </Button>
                                </div>
                            </div>
                        </section>
                    )}
                    {showMessage &&
                        !listDuplicateListMessage.includes(message) &&
                        message !== undefined && (
                            <MessageBox
                                type={type}
                                title={
                                    <span>
                                        {`${message}`}{' '}
                                        {movedId && (
                                            <>
                                                <a
                                                    className={dt(['!text-black', '!underline'])}
                                                    href={`/mylist?id=${movedId}`}
                                                >
                                                    {movedTo}
                                                </a>
                                                .
                                            </>
                                        )}
                                    </span>
                                }
                                level="section"
                                automationId="list-notification-message"
                                onClose={this.closeMessageBox}
                            />
                        )}
                    <section
                        className={`${cx('listsContainer')} ${dt([
                            'w-full',
                            'bg-white',
                            'smOnly:border-none',
                            'smOnly:rounded-none',
                            'text-black',
                        ])}`}
                    >
                        {!isSharedListPrivate && (
                            <FilterPanel
                                featureFlags={featureFlags}
                                actions={actions}
                                headers={headers}
                                myListsDetails={myListsDetails}
                                savedListActions={savedListActions}
                                shareList={shareList}
                                savedList={savedList}
                                location={location}
                                messagesTexts={messagesTexts}
                                openSlider={this.openSlider}
                                authenticationSuccess={authenticationSuccess}
                                preferences={preferences}
                                authStatus={this.isUserLoggedOn()}
                                getListCategorySort={this.getListCategorySort}
                                accounts={accounts}
                                showTopMessage={this.showTopMessage}
                                isShared={isShared}
                                typeInfoTheme={typeInfoTheme}
                                deviceType={deviceType}
                            />
                        )}
                        {this.atcSuccess() && (
                            <MessageBox
                                type={type}
                                title={message}
                                level="section"
                                automationId="list-notification-message"
                                onClose={this.closeMessageBox}
                            />
                        )}
                        <ListDetailsPanel
                            id={get(query, 'id', 'myFavorites')}
                            isLoggedIn={this.isUserLoggedOn()}
                            actions={{ ...actions, ...savedListActions }}
                            createList={actions.createList}
                            pageEvent={actions.myListAnalyticsAction}
                            savedList={savedList}
                            addToCart={addToCart}
                            addToCartActions={addToCartActions}
                            LoaderAction={LoaderAction}
                            openSlider={this.openSlider}
                            toggleMostWanted={toggleMostWanted}
                            location={location}
                            headers={headers}
                            preferences={preferences}
                            mountOnServer={mountOnServer}
                            deviceType={deviceType}
                            deleteList={deleteList}
                            showTopMessage={this.showTopMessage}
                            MiniPDPActions={MiniPDPActions}
                            updatedItem={updatedItem}
                            isShared={isShared}
                            draftOrder={this.props.draftOrder}
                            closeParentDialog={this.closeSuccessMsg}
                            listLandingError={showMessage}
                            messagesTexts={messagesTexts}
                            error={error}
                            isOOSListingEnabled={isOOSListingEnabled}
                            myAlertsProps={myAlertsProps}
                            MTLSavedLists={MTLSavedLists}
                            lastRemovedListItem={lastRemovedListItem}
                            closeMessageBox={this.closeMessageBox}
                            enableMiniPDPFeature={featureFlags.enableMiniPDPFeature}
                        />
                    </section>
                </CAMNavLayout>
            </div>
        );
    }
}

export default ListLandingPage;
